export default __webpack_public_path__ + "static/media/twitterTheme-boy.a235e843.svg";